export default __webpack_public_path__ + "static/media/house-alwaysOn.14cef8a7.gif";